import { render } from "./WelcomeMessage.vue?vue&type=template&id=385aa377&scoped=true"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=385aa377&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385aa377"]])

export default __exports__